export const LOGIN_LOADING  = 'LOGIN_LOADING'
export const LOGIN_ERROR    = 'LOGIN_ERROR'
export const LOGIN_SUCCESS  = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const UPDATE_PROGRESS_SUCCESS = 'UPDATE_PROGRESS_SUCCESS'
export const UPDATE_LAST_PROGRESS_SUCCESS = 'UPDATE_LAST_PROGRESS_SUCCESS'
export const UPDATE_ENDTEST_SUCCESS = 'UPDATE_ENDTEST_SUCCESS'
export const UPDATE_CHAPTERS_SUCCESS = 'UPDATE_CHAPTERS_SUCCESS'
export const UPDATE_ACCOUNT_API_SUCCESS = 'UPDATE_ACCOUNT_API_SUCCESS'
export const UPDATE_ACCOUNT_API_ERROR = 'UPDATE_ACCOUNT_API_ERROR'